module.exports = __webpack_public_path__ + "img/15.7ae7265e.jpg";